export default [
    {
        path: '/section',
        name: 'Section',
        component: () => import("@/views/Page/Section/Section.vue"),
        meta: {
            title: '#Default# | Section',
        },
    },
    {
        path: '/section/:sectionId/add-students',
        name: 'SectionAddStudents',
        component: () => import("@/views/Page/Section/SectionAddStudents.vue"),
        props: true,
        meta: {
            title: '#Default# | Add Students to Section',
        },
    }
];

